import { createStructureStatementHandler } from '../../createStructureStatementHandler';
import { getReadoutName } from '../../utils/nameFormat';
export const removeReadoutFieldStmtInstruction = `
#### Remove readout field

- Syntax: \`remove readoutField <field_name> in <readout_name>;\`
- Example: \`remove readoutField name in ${getReadoutName('Option')};\`
- Example: \`remove readoutField category.name in ${getReadoutName('Variant')};\` (Use \`.property_name\` when accessing specific attributes within a related entity is required.)
`;
export const stmtRemoveReadoutField = ({ readoutFieldName, readoutName }) => {
    return `remove readoutField ${readoutFieldName} in ${readoutName};`;
};
export const removeReadoutFieldHandler = createStructureStatementHandler({
    type: 'remove readoutField',
    parse: line => {
        const match = /^remove (readoutField|detailField) (?<readoutFieldName>[\w.]+) in (?<readoutName>\w+)/.exec(line);
        return match?.groups
            ? {
                type: 'remove readoutField',
                readoutFieldName: match.groups.readoutFieldName,
                readoutName: match.groups.readoutName,
            }
            : null;
    },
    apply: (stmt, builder) => {
        builder.updateStructure(it => {
            return it.removeReadoutField({
                readoutFieldName: stmt.readoutFieldName,
                readoutName: stmt.readoutName,
            });
        });
    },
});
//# sourceMappingURL=RemoveReadoutFieldStmt.js.map